import React from 'react';
import { APP_PREFIX_PATH } from 'configs/AppConfig';

export class FinanceProtectedRoute {

    static finance = [
        {
            key: 'finance-clienti',
            path: `${APP_PREFIX_PATH}/finance/clienti`,
            component: React.lazy(() => import('views/finance-views/clienti')),
        },
        {
            // `clienti` e non `pazienti`: getAreaFromPath riconosce l'area dal
            // path, e '/pazienti' e' un base path dell'area medica. Chiamarla
            // cosi' farebbe comparire a un contabile la richiesta di cambiare
            // area mentre e' gia' nella sua.
            key: 'finance-scheda-cliente',
            path: `${APP_PREFIX_PATH}/finance/clienti/:patientId`,
            component: React.lazy(() => import('views/finance-views/clienti/scheda-cliente')),
        },
        {
            key: 'finance-piano-dei-conti',
            path: `${APP_PREFIX_PATH}/finance/piano-dei-conti`,
            component: React.lazy(() => import('views/finance-views/roadmap/piano-dei-conti')),
        },
        {
            key: 'finance-corrispettivi-rt',
            path: `${APP_PREFIX_PATH}/finance/corrispettivi-rt`,
            component: React.lazy(() => import('views/finance-views/roadmap/corrispettivi/DailyReceiptsPage')),
        },
        {
            key: 'finance-mexal',
            path: `${APP_PREFIX_PATH}/finance/mexal`,
            component: React.lazy(() => import('views/finance-views/roadmap/mexal')),
        },
        {
            key: 'finance-shell',
            path: `${APP_PREFIX_PATH}/finance/shell`,
            component: React.lazy(() => import('views/finance-views/roadmap/shell')),
        },
        {
            key: 'finance-magazzino',
            path: `${APP_PREFIX_PATH}/finance/magazzino`,
            component: React.lazy(() => import('views/finance-views/roadmap/magazzino')),
        },
        {
            key: 'finance-tesoreria',
            path: `${APP_PREFIX_PATH}/finance/tesoreria`,
            component: React.lazy(() => import('views/finance-views/roadmap/tesoreria')),
        },
        {
            key: 'finance-passivo',
            path: `${APP_PREFIX_PATH}/finance/passivo`,
            component: React.lazy(() => import('views/finance-views/roadmap/passivo')),
        },
        {
            key: 'finance-registri',
            path: `${APP_PREFIX_PATH}/finance/registri`,
            component: React.lazy(() => import('views/finance-views/roadmap/registri')),
        },
        {
            key: 'finance-causali',
            path: `${APP_PREFIX_PATH}/finance/causali`,
            component: React.lazy(() => import('views/finance-views/roadmap/causali')),
        },
        {
            key: 'finance-prima-nota',
            path: `${APP_PREFIX_PATH}/finance/prima-nota`,
            component: React.lazy(() => import('views/finance-views/roadmap/prima-nota')),
        },
        {
            key: 'finance-prima-nota-conti',
            path: `${APP_PREFIX_PATH}/finance/prima-nota-conti`,
            component: React.lazy(() => import('views/finance-views/roadmap/prima-nota-conti')),
        },
        {
            key: 'finance-attivo',
            path: `${APP_PREFIX_PATH}/finance/attivo`,
            component: React.lazy(() => import('views/finance-views/roadmap/attivo')),
        },
        {
            key: 'finance-documentale',
            path: `${APP_PREFIX_PATH}/finance/documentale`,
            component: React.lazy(() => import('views/finance-views/roadmap/documentale')),
        },
        {
            key: 'finance-processi',
            path: `${APP_PREFIX_PATH}/finance/processi`,
            component: React.lazy(() => import('views/finance-views/roadmap/processi')),
        },
        {
            key: 'finance-scheda-contabile-fornitore',
            path: `${APP_PREFIX_PATH}/finance/scheda-contabile-fornitore`,
            component: React.lazy(() => import('views/finance-views/roadmap/scheda-contabile-fornitore')),
        },
        {
            key: 'finance-scadenzario-passivo',
            path: `${APP_PREFIX_PATH}/finance/scadenzario-passivo`,
            component: React.lazy(() => import('views/finance-views/roadmap/scadenzario-passivo')),
        },
        {
            key: 'finance-fattura-estera',
            path: `${APP_PREFIX_PATH}/finance/fattura-estera`,
            component: React.lazy(() => import('views/finance-views/roadmap/fattura-estera')),
        },
        {
            key: 'finance-reso-fornitore',
            path: `${APP_PREFIX_PATH}/finance/reso-fornitore`,
            component: React.lazy(() => import('views/finance-views/roadmap/reso-fornitore')),
        },
        {
            key: 'finance-bilancio-verifica',
            path: `${APP_PREFIX_PATH}/finance/bilancio-verifica`,
            component: React.lazy(() => import('views/finance-views/roadmap/bilancio-verifica')),
        },
        {
            key: 'finance-ordini-nso-mso',
            path: `${APP_PREFIX_PATH}/finance/ordini-nso-mso`,
            component: React.lazy(() => import('views/finance-views/roadmap/ordini-nso-mso')),
        },
        {
            key: 'finance-compliance',
            path: `${APP_PREFIX_PATH}/finance/compliance`,
            component: React.lazy(() => import('views/finance-views/roadmap/compliance')),
        },
        {
            key: 'finance-salda-conto',
            path: `${APP_PREFIX_PATH}/finance/salda-conto`,
            component: React.lazy(() => import('views/finance-views/roadmap/salda-conto')),
        },
        {
            key: 'finance-registri-sezionali',
            path: `${APP_PREFIX_PATH}/finance/registri-sezionali`,
            component: React.lazy(() => import('views/finance-views/roadmap/registri-sezionali')),
        },
        {
            key: 'finance-fatturazione-attiva',
            path: `${APP_PREFIX_PATH}/finance/fatturazione-attiva`,
            component: React.lazy(() => import('views/finance-views/roadmap/fatturazione-attiva')),
        },
        {
            key: 'finance-coda-pratiche-fatturare',
            path: `${APP_PREFIX_PATH}/finance/coda-pratiche-fatturare`,
            component: React.lazy(() => import('views/finance-views/roadmap/coda-pratiche-fatturare')),
        },
        {
            key: 'finance-fatture-inviate',
            path: `${APP_PREFIX_PATH}/finance/fatture-inviate`,
            component: React.lazy(() => import('views/finance-views/fatture-emesse')),
        },
        {
            key: 'finance-fatture-emesse',
            path: `${APP_PREFIX_PATH}/finance/fatture-emesse`,
            component: React.lazy(() => import('views/finance-views/fatture-emesse')),
        },
        {
            key: 'finance-fatture',
            path: `${APP_PREFIX_PATH}/finance/fatture`,
            component: React.lazy(() => import('views/finance-views/fatture')),
        },
        {
            key: 'finance-pre-fatture',
            path: `${APP_PREFIX_PATH}/finance/pre-fatture`,
            component: React.lazy(() => import('views/finance-views/roadmap/pre-fatture')),
        },
        {
            key: 'finance-tracking-pratica-asl',
            path: `${APP_PREFIX_PATH}/finance/tracking-pratica-asl`,
            component: React.lazy(() => import('views/finance-views/roadmap/tracking-pratica-asl')),
        },
        {
            key: 'finance-migrazione-pratica',
            path: `${APP_PREFIX_PATH}/finance/migrazione-pratica`,
            component: React.lazy(() => import('views/finance-views/roadmap/migrazione-pratica')),
        },
        {
            key: 'finance-corrispettivi',
            path: `${APP_PREFIX_PATH}/finance/corrispettivi`,
            component: React.lazy(() => import('views/finance-views/roadmap/corrispettivi')),
        },
        {
            key: 'finance-wizard-fattura-pa',
            path: `${APP_PREFIX_PATH}/finance/wizard-fattura-pa`,
            component: React.lazy(() => import('views/finance-views/roadmap/wizard-fattura-pa')),
        },
        {
            key: 'finance-vendita-immediata-differita',
            path: `${APP_PREFIX_PATH}/finance/vendita-immediata-differita`,
            component: React.lazy(() => import('views/finance-views/roadmap/vendita-immediata-differita')),
        },
        {
            key: 'finance-fattura-libera',
            path: `${APP_PREFIX_PATH}/finance/fattura-libera`,
            component: React.lazy(() => import('views/finance-views/roadmap/fattura-libera')),
        },
        {
            key: 'finance-rifatturazione-assistita',
            path: `${APP_PREFIX_PATH}/finance/rifatturazione-assistita`,
            component: React.lazy(() => import('views/finance-views/roadmap/rifatturazione-assistita')),
        },
        {
            key: 'finance-template-editor-mds-asl',
            path: `${APP_PREFIX_PATH}/finance/template-editor-mds-asl`,
            component: React.lazy(() => import('views/finance-views/roadmap/template-editor-mds-asl')),
        },
        {
            key: 'finance-dashboard-executive',
            path: `${APP_PREFIX_PATH}/finance/dashboard-executive`,
            component: React.lazy(() => import('views/finance-views/roadmap/dashboard-executive')),
        },
        {
            key: 'finance-pacchetto-trimestrale-commercialista',
            path: `${APP_PREFIX_PATH}/finance/pacchetto-trimestrale-commercialista`,
            component: React.lazy(() => import('views/finance-views/roadmap/pacchetto-trimestrale-commercialista')),
        },
    ];

    static getNavTree() {
        return this.finance;
    }
}

export default FinanceProtectedRoute;
